import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M3.59 3C2.712 3 2 3.713 2 4.591C2 5.47 2.712 6.183 3.59 6.183H20.409C21.287 6.183 22 5.47 22 4.591C22 3.713 21.287 3 20.409 3H3.59Z',
                    fill: '#5877A6',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M4.27197 4.36401V20.728C4.27197 21.481 4.88297 22.091 5.63597 22.091H18.363C19.116 22.091 19.726 21.481 19.726 20.728V4.36401H4.27197Z',
                    fill: '#C9DEF2',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M7.4541 4.36401H10.6361V22.091H7.4541V4.36401Z',
                    fill: '#5877A6',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M13.3628 12.773V19.137C13.3628 19.765 13.8718 20.273 14.4998 20.273C15.1268 20.273 15.6358 19.765 15.6358 19.137V12.773C15.6358 12.145 15.1268 11.637 14.4998 11.637C13.8718 11.637 13.3628 12.145 13.3628 12.773Z',
                    fill: 'white',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const AtmColored = React.forwardRef(IconComponent);
AtmColored.displayName = 'AtmColored';

export { AtmColored };
